import { Plus } from 'lucide-react';

export interface AddItemCardProps {
  label?: string;
  onClick?: () => void;
  className?: string;
}

// Figma dev-mode spec (nodes 7555:19775 / 7555:19776) is 1px dashed, but
// the team agreed in review to bump to 2px so the dashed frame is more
// noticeable against the page background.
export function AddItemCard({
  label = 'Add item',
  onClick,
  className = '',
}: AddItemCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        'flex h-16 w-full items-center justify-center gap-2 px-4 py-3',
        'rounded-xl border-2 border-dashed border-border-strong bg-transparent',
        'text-sm font-semibold text-muted-foreground cursor-pointer',
        'hover:bg-muted transition-colors',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {label}
      <Plus size={16} />
    </button>
  );
}
